import React, { useMemo, useState } from "react";
import Table from 'react-bootstrap/Table';
import 'bootstrap/dist/css/bootstrap.min.css';
import PaginationByApi from "../Pagination/paginationByApi";
import Pagination from "../Pagination/pagination";
import ItemSelect from "../SelectItemsPerPage/SelectItemsPerPage";
import ExportExcel from "../Table/ExportExcel";
import ExportExcelFromApi from "../Table/ExportExcelFromApi";

export const NewDataTable = (props) => {
    const {currentPage, pageSize, setCurrentPage, setPageSize} = props;
    const currentTableData = props?.data;

    const getCellHeaders = () => {
        let cols = props.cellHeaders.map((item, id) => {
            return (
                <th key={id}>{item}</th>
            )
        })
        return (<tr>
            {props.addSerialNo && <th>S.NO.</th>}
            {cols}
        </tr>)
    }
    const getBody = () => {
        const { customButtonName } = props;
        return currentTableData && currentTableData?.map((item, index) => {
            return (
                <tr key={index}>
                    {props.addSerialNo &&
                        <td>{index + 1}</td>}
                    {
                        props.keys.map((key, ind) => {
                            if (ind === props.clickColumnIndex) {
                                return (
                                    <td key={ind} className="row-link"
                                        onClick={() => props.onRowClick(item)}>{props.convertValueToString ? item[key]?.toString() : item[key]}</td>
                                )
                            } else if (key === "customButtons") {
                                return <td key={ind}>
                                    <button className="custom-button"
                                        onClick={() => props.onCustomButtonClick(item)}>{customButtonName || "Edit"}</button>
                                </td>
                            }
                            else if (key === "FreezecustomButtons") {
                                return <td key={ind}>
                                    <div  className="dataTable-btn"><button className="tpaBtn" 
                                        onClick={() => props.onCustomButtonClick(item)}><i class="fa fa-edit" ></i> {customButtonName || ""} </button>
                                    <button className="tpaBtn"
                                        onClick={() => props.onCustomDeletButtonClick(item)}><i class="fa fa-trash" ></i> </button>    
                                        </div>
                                </td>
                            } else if (props.converTdToComponent == key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else if (props.secondconverTdToComponent == key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else if (props.thirdconverTdToComponent == key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else if (key === 'paymentMethod') {
                                if (item.paymentMethod?.length) {
                                    let payMethod = item.paymentMethod.replace(/]/g, '')
                                    payMethod = payMethod.replace(/\[/g, '')
                                    return (<td key={ind}>
                                        {payMethod}
                                    </td>)
                                } else {
                                    return (<td key={ind}>
                                        {item.paymentMethod}
                                    </td>)
                                }
                            } else if (props.fourthconverTdToComponent === key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else if (props.fifthconvertTdToComponent === key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else if (props.sixthconvertTdToComponent === key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else if (props.seventhconvertTdToComponent === key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else if (props.AAconvertTdToComponent === key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else if(props.upfrontconvertTdToComponent === key) {
                                return (<td key={ind}>
                                    {props.componentToBeConverted(item, key)}
                                </td>)
                            } else {
                                return (
                                    <td key={ind}>{props.convertValueToString ? item[key]?.toString() : item[key]}</td>
                                )
                            }

                        })
                    }
                </tr>
            )
        })
    }


    return (<>


        <div className="proposal-table">
            {props.showExcelDownload ? <div className="excel-download">
                <ExportExcelFromApi
                    cellHeaders={props.cellHeaders}
                    apiCall={props.callUpfrontPaymentReportApi}
                    keys={props.keys}
                    fileName={props.fileName}
                    addSerialNo={props.addSerialNo}
                />
            </div> : ''}

            {!props.PerPageApiData && props.paginationItems ? <ItemSelect itemsPerPage={pageSize}
                setItemsPerPage={setPageSize} /> : ''}
            <Table responsive striped bordered={true} hover variant="light">
                <thead>
                    {getCellHeaders()}
                </thead>
                <tbody>
                    {getBody()}
                </tbody>
            </Table>
            {props.PerPageApiData && props.paginationItems ? <PaginationByApi
                itemsCount={props.paginationItems.totalItems}
                itemsPerPage={props.itemsPerPage}
                currentPage={props.currentPage + 1}
                setCurrentPage={props.setCurrentPage}
                alwaysShown={props.alwaysShown}
            /> : ''}
            { <Pagination
                className="pagination-bar"
                currentPage={currentPage + 1}
                totalCount={props.totalRecords}
                pageSize={pageSize}
                onPageChange={page => setCurrentPage(page - 1)}
            />}
        </div>
    </>)
}

export default NewDataTable;
